import ReactDOM from 'react-dom/client'
import App from './App'
import { isMacOSSafari } from 'utils/checkDevice'

if (process.env.REACT_APP_MOCK_API === "enable") {
  const { worker } = require("./mocks/browser");
  worker.start({
    onUnhandledRequest: 'bypass',
  });
}

const stage = document.getElementById('stage') as HTMLElement
const siteCode = stage.dataset.siteCode || ""
const root = ReactDOM.createRoot(stage)
if (siteCode && !isMacOSSafari()) {
  root.render(
    <App siteCode={siteCode} />
  );
}
